const getFocusTileIndex = ({ focusFirstTile, focusLastTile, products }) =>
  focusFirstTile ? 0 : focusLastTile ? products.length - 1 : null;

export default getFocusTileIndex;
